import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
